import axios from 'axios';
import Jsona from 'jsona';
import moment from 'moment';
import config from '../../config';
import { kycActions } from '../slices/kyc-slice';
import { fetchCities } from './location-actions';

export const getUserKYCData = (identityNumber, userPayload) => {
  // const apiBaseUrl =
  //   config.REACT_APP_USER_KYC_URL +
  //   '?' +
  //   config.REACT_APP_USER_KYC_URL_IDENTITY_QUERY +
  //   '=' +
  //   identityNumber;
  // const additionalHeaders = {};

  // if (config.REACT_APP_USER_KYC_URL_ADDITIONAL_HEADERS) {
  //   const headers = config.REACT_APP_USER_KYC_URL_ADDITIONAL_HEADERS.split(',');
  //   headers.forEach((h) => {
  //     const keyvaluepair = h.split(':');
  //     additionalHeaders[keyvaluepair[0]] = keyvaluepair[1];
  //   });
  // }

  // const request = axios.get(apiBaseUrl, {
  //   headers: {
  //     Authorization: config.REACT_APP_USER_KYC_URL_AUTHORIZATION,
  //     ...additionalHeaders,
  //   },
  // });

  const apiBaseUrl =
    config.REACT_APP_IDENTITY_BASE_URL + config.REACT_APP_UM_USER_KYC_URL;

  const params = {
    tenant: config.REACT_APP_TENANT,
    personommer: identityNumber,
  };

  const request = axios.get(apiBaseUrl, { params });

  return (dispatch) => {
    dispatch(
      kycActions.setLoading({
        isLoading: true,
        willClearError: true,
      })
    );

    request.then(
      ({ data }) => {
        const fetchedData = new Jsona().deserialize(data);
        const { responseCode, responseMessage, basic, extended } = fetchedData;

        if (responseCode.toUpperCase() === 'OK') {
          const kycData = { ...basic, ...extended };
          let userData = {
            identityNumber,
            firstname: kycData.firstName,
            middlename: kycData.middleName,
            lastname: kycData.surName,
            birthDate: kycData.dateOfBirth,
            // nationality: config.REACT_APP_DEFAULT_COUNTRY_ISO2_CODE,
            gender: kycData.gender.toLowerCase(),
            // addressCountry: config.REACT_APP_USE_SOURCE_COUNTRIES
            //   ? config.REACT_APP_DEFAULT_COUNTRY_ID
            //   : config.REACT_APP_DEFAULT_COUNTRY_ISO2_CODE,
            addressState: kycData.county,
            address1: `${kycData.street} ${kycData.city}`,
            address2: '',
            addressCity: kycData.municipality,
            addressZipCode: kycData.zipCode,
          };

          if (config.REACT_APP_USER_KYC_CREATE_DOCUMENT === 'true') {
            userData = {
              ...userData,
              documentType: 'nationalidcard',
              documentExpiryDate: moment().add(1, 'y'),
            };
          }

          if (config.REACT_APP_USE_SENDING_CITIES) {
            dispatch(
              fetchCities(
                null,
                null,
                config.REACT_APP_DEFAULT_COUNTRY_ID,
                config.REACT_APP_TENANT,
                'SENDING',
                'kyc',
                kycData.municipality,
                userData
              )
            );
          } else {
            dispatch(kycActions.setUserKYCData(userData));
          }
        } else {
          console.log('KYC getUserKYCData error: ' + responseMessage);

          dispatch(kycActions.setError(responseMessage));
        }
      },
      (error) => {
        let errorMessage = config.generalError;

        try {
          if (error.messages && typeof error.messages === 'string') {
            errorMessage = error.messages;
          } else if (
            error.response.data.message &&
            typeof error.response.data.message === 'string'
          ) {
            errorMessage = error.response.data.message;
          } else if (
            error.response.data.errors.message &&
            typeof error.response.data.errors.message === 'string'
          ) {
            errorMessage = error.response.data.errors.message;
          }
        } catch {
          console.log('error.response: ', error.response);
          console.log('error.request: ', error.request);
          console.log('error.config: ', error.config);
          if (error.response) {
            errorMessage = 'Fetch getUserKYCData failed!';
          }
        }

        console.log('KYC getUserKYCData error: ' + errorMessage);

        dispatch(kycActions.setError(errorMessage));
      }
    );
  };
};

export const setCancelIncoming = (isCancel) => {
  return (dispatch) => {
    dispatch(kycActions.setCancelIncoming(isCancel));
  };
};

export const clearKYCUserData = () => {
  return (dispatch) => {
    dispatch(kycActions.clearUserKYCData());
  };
};
